import { TEAMS } from "./configs";

/**
 * Parses an NBA matchup string and returns the team names and color based on abbreviations.
 *
 * @param matchup - The matchup string in format "ABBR vs. ABBR" (e.g., "NYK vs. DET")
 * @returns An array with [[firstTeamName, secondTeamName], colorCode]
 *
 * @example
 * ```typescript
 * const result = getCantMissHighlightsInfo("NYK vs. DET");
 * console.log(result); // [["Knicks", "Pistons"], "#FF7112"]
 *
 * const result2 = getCantMissHighlightsInfo("LAL vs. BOS");
 * console.log(result2); // [["Lakers", "Celtics"], "#FCCC12"]
 * ```
 */
const getCantMissHighlightsInfo = (
  matchup: string,
): [label: string[], color: string] => {
  const abbrs = matchup.split(" vs. ");

  if (abbrs.length !== 2) {
    console.warn(
      `Invalid matchup format: "${matchup}". Expected "ABBR vs. ABBR"`,
    );
    return [["Knicks", "Pistons"], "#FF7112"];
  }
  const firstTeam = TEAMS[abbrs[0]];
  const secondTeam = TEAMS[abbrs[1]];

  if (!firstTeam || !secondTeam) {
    console.warn(
      `Could not find teams for matchup: "${matchup}". ` +
        `First team (${abbrs[0]}): ${!!firstTeam}, ` +
        `Second team (${abbrs[1]}): ${!!secondTeam}`,
    );
    return [["Knicks", "Pistons"], "#FF7112"];
  }

  const color = firstTeam.color;

  return [[firstTeam.name, secondTeam.name], color];
};

export { getCantMissHighlightsInfo };
